import tools from "tools";

let init = false;

const mobile = (player, playerID) => {
  player.on("touchstart", function(e) {
    if (
      this.player().controls() &&
      e.srcElement.id === `${playerID}_html5_api`
    ) {
      if (this.player().paused()) {
        this.player().play();
      } else if (player.userActive()) {
        this.player().pause();
      }
    }
  });
  tools.addCSS("mobile", ".video-js{font-size : 15px !important;}");
};

export default function mobileInit(player, playerID) {
  if (init || !("ontouchstart" in document.documentElement)) {
    return 0;
  }
  init = true;
  setTimeout(() => {
    mobile(player, playerID);
  }, 700);
  return 1;
}



// WEBPACK FOOTER //
// ./src/js/videoJSExtensions/videojs-mobile.js